<template>
    <div id="page-not-found">
        <div class="container-xl">
            <div class="logo-wrap">
                <router-link :to="{ name: 'Home', params: {lang: currentLangName()}}">
                    <img src="@/assets/images/brand/univer-logo.svg" class="img-fluid" alt="Univer"  />
                </router-link>
            </div>
            <h1>404</h1>        
            <div class="not-found-text">{{ lang('page_not_found')}}</div>
            <router-link :to="{name: 'Home', params: {lang: currentLangName()}}" class="btn btn--primary"><span>{{ lang("vissza_a_fooldalra")}}</span></router-link>            
        </div>        
    </div>
</template>

<script>


export default {
    mounted(){
        this.setMetaTags({
            title: 'Univer', 
            desc: this.lang('meta_description_homepage'), 
            keywords:this.lang('meta_keywords_homepage'), 
            ogType: 'website', 
            ogTitle: 'Univer',                         
            ogImage: null, 
            ogImageWidth: null, 
            ogImageHeight: null, 
            ogDesc:this.lang('meta_description_homepage')
        })
    }
}
</script>